/**
 * Client-side mirror of backend auditLogHygiene — keep Firestore audit evidence lean.
 * Do not import backend modules from the CRA app.
 */

export const AUDIT_LOG_SKIP_FIRESTORE_ACTIONS = new Set<string>([
  'firebase_auth_success',
  'automated_user_agent_detected',
]);

export const AUDIT_LOG_SKIP_SUCCESS_ACTION_PREFIXES = ['secure_storage_'] as const;

export const AUDIT_LOG_NOISE_RETENTION_DAYS = 90;
export const AUDIT_LOG_EVIDENCE_RETENTION_DAYS = 365;

export const AUDIT_LOG_SHORT_RETENTION_ACTIONS = new Set<string>([
  'rate_limit_violation',
  'firebase_auth_header_missing',
  'firebase_auth_token_empty',
  'firebase_auth_invalid_token',
]);

export function shouldSkipFirestoreAuditWrite(
  action: string,
  result?: string
): boolean {
  if (AUDIT_LOG_SKIP_FIRESTORE_ACTIONS.has(action)) return true;
  if (result === 'success') {
    for (const prefix of AUDIT_LOG_SKIP_SUCCESS_ACTION_PREFIXES) {
      if (action.startsWith(prefix)) return true;
    }
  }
  return false;
}

export function auditLogExpireAt(action: string, severity: string): Date {
  const days =
    AUDIT_LOG_SHORT_RETENTION_ACTIONS.has(action) ||
    severity === 'low' ||
    action.startsWith('secure_storage_')
      ? AUDIT_LOG_NOISE_RETENTION_DAYS
      : AUDIT_LOG_EVIDENCE_RETENTION_DAYS;
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + days);
  return d;
}
